export const NOTIFICATIONS_POLLING_INTERVAL = 1000 * 60 * 4; // 4 minutes
